import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'

export function settingsInProgress(isLoading) {
  return { type: ActionType.SETTINGS_INPROGRESS, isLoading }
}

export function clinicSettingLoaded({ customerid, key, data }) {
  return { type: ActionType.SETTINGS_CLINIC_LOADED, customerid, key, data }
}

export function resolvedSettingLoaded({ customerid, key, value }) {
  return { type: ActionType.SETTINGS_RESOLVED_LOADED, customerid, key, value }
}

// The three settings forms are shared by the clinic page and the company page:
// a call carrying `companyid` (and no `customerid`) goes to the company-level
// row instead. The reducer slot for a company row is 'company:<id>'.
const isCompany = ({ customerid, companyid }) => !customerid && !!companyid
const slotOf = ({ customerid, companyid }) =>
  isCompany({ customerid, companyid }) ? 'company:' + companyid : customerid

export function fetchClinicSetting({ customerid, companyid, key }) {
  return async (dispatch) => {
    try {
      dispatch(settingsInProgress(true))
      const svc = serviceInterface.SettingsService()
      const data = isCompany({ customerid, companyid })
        ? await svc.getCompanySetting({ companyid, key })
        : await svc.getClinicSetting({ customerid, key })
      dispatch(settingsInProgress(false))
      if (data && !data.error) {
        dispatch(
          clinicSettingLoaded({ customerid: slotOf({ customerid, companyid }), key, data: data.data || null })
        )
      }
      return data
    } catch (err) {
      console.log(err)
      dispatch(settingsInProgress(false))
      return { error: true }
    }
  }
}

export function fetchResolvedClinicSetting({ customerid, key }) {
  return async (dispatch) => {
    try {
      dispatch(settingsInProgress(true))
      const data = await serviceInterface
        .SettingsService()
        .getResolvedClinicSetting({ customerid, key })
      dispatch(settingsInProgress(false))
      if (data && !data.error) {
        dispatch(
          resolvedSettingLoaded({
            customerid,
            key,
            value: data.data ? data.data.value : null,
          })
        )
      }
      return data
    } catch (err) {
      console.log(err)
      dispatch(settingsInProgress(false))
      return { error: true }
    }
  }
}

export function saveClinicSetting({ customerid, companyid, key, value }) {
  return async (dispatch) => {
    try {
      dispatch(settingsInProgress(true))
      const svc = serviceInterface.SettingsService()
      const data = isCompany({ customerid, companyid })
        ? await svc.updateCompanySetting({ companyid, key, value })
        : await svc.updateClinicSetting({ customerid, key, value })
      dispatch(settingsInProgress(false))
      if (data && !data.error) {
        message.success('Settings saved')
        dispatch(
          clinicSettingLoaded({ customerid: slotOf({ customerid, companyid }), key, data: data.data || null })
        )
      } else if (data && data.message) {
        message.error(data.message)
      }
      return data
    } catch (err) {
      console.log(err)
      dispatch(settingsInProgress(false))
      message.error('Failed to save settings')
      return { error: true }
    }
  }
}

export function resetClinicSetting({ customerid, companyid, key }) {
  return async (dispatch) => {
    try {
      dispatch(settingsInProgress(true))
      const svc = serviceInterface.SettingsService()
      const data = isCompany({ customerid, companyid })
        ? await svc.resetCompanySetting({ companyid, key })
        : await svc.resetClinicSetting({ customerid, key })
      dispatch(settingsInProgress(false))
      if (data && !data.error) {
        message.success('Reset to global defaults')
        dispatch(clinicSettingLoaded({ customerid: slotOf({ customerid, companyid }), key, data: null }))
      } else if (data && data.message) {
        message.error(data.message)
      }
      return data
    } catch (err) {
      console.log(err)
      dispatch(settingsInProgress(false))
      message.error('Failed to reset settings')
      return { error: true }
    }
  }
}
